import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[rtSelectEmptyState]',
})
export class Select2EmptyStateDirective {
  constructor(public templateRef: TemplateRef<void>) {}
}
